import React from 'react';
import SMReservationBaseView from './SMReservationBaseView';
import SMReservationCalendarMobileView from './SMReservationCalendarMobileView';
import SMStayReservationCalendarMobileView from './SMStayReservationCalendarMobileView';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';
import SMUserContactView from 'components/users/SMUserContactView';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import ReactSlick from 'react-slick';

const SliderLastNumber = 3; //Mobile 最後のスライドの番号

class SMReservationMobileView extends SMReservationBaseView {

  constructor(props) {
    super(props);

    if (this.state.validatedReservation != null) {
      // 未ログイン状態からログイン状態になった際にセッション情報から選択肢を復活する
      this.state.currentSlider = SliderLastNumber;
      this.state.reloadSession = true;
    } else {
      this.state.currentSlider = 0;
      this.state.reloadSession = false;
    }

    this.hourDidSelect = this.hourDidSelect.bind(this);
    this.gotoSlide = this.gotoSlide.bind(this);
  }

  componentDidMount() {
    this.subscribeOptionSelectEvent();
    this.subscribeGuestsSelectEvent();
    $(this.refs.mobileMain).outerHeight(this.calcMobileMainHeight());
    // 内部のTouchMoveイベントハンドラを無効にするhack
    this.slider.innerSlider.swipeMove = (()=>{});

    if (this.state.reloadSession) {
      this.slider.slickGoTo(SliderLastNumber);
      $(this.refs.mobileMain).outerHeight(this.calcMobileMainHeight() + this.getDefaultFooterHeight());
    }
  }

  componentDidUpdate() {
    if (this.state.plan && this.state.isHourly != null) {
      this.subscribeOptionSelectEvent();
    }
    if (this.state.plan && this.state.isHourly != null) {
      this.subscribeGuestsSelectEvent();
    }
    if ($(this.refs.hourList) != null) {
      $(this.refs.hourList).outerHeight($(window).height());
    }
    if (this.state.reloadSession) {
      // ボタン押した瞬間Sliderが再度動きおかしくなるためもう一度だけ設定する
      this.slider.slickGoTo(SliderLastNumber);
      this.clearReloadSession();
    }
  }

  clearReloadSession() {
    if (this.state.reloadSession) {
      this.setState({
        reloadSession: false,
      });
    }
  }

  calcMobileMainHeight() {
    return $(window).height() - this.calcFooterHeight();
  }

  calcFooterHeight() {
    if (this.refs.footer) {
      return $(this.refs.footer).outerHeight(true);
    }
    // 初期表示の際に項目が多いと一番下が隠れるためある程度適当な余白をとる
    return this.getDefaultFooterHeight();
  }

  getDefaultFooterHeight() {
    return 100;
  }

  nextSlide() {
    this.slider.slickNext();
  }

  gotoSlide(slideNumber) {
    this.slider.slickGoTo(slideNumber);
    this.setState({
      currentSlider: slideNumber,
    });

    if(slideNumber == 0) {
      this.resetReservation();
      this.setState({
        validatedReservation: null,
        isRequestViewOpen: false,
        isContactViewOpen: false,
        priceText: "",
        priceExtraText: "",
        reservedDateText: I18n.t("service.label_000050"),
        numberOfGuests: 1,
        optionItems: {},
        optionFoods: {},
        isValid: false,
        errors: [],
      });
    }
  }

  showProgressStatus(currentSlider, point) {
    if (currentSlider == point) {
      return "is-current";
    } else if (currentSlider > point) {
      return "is-checked is-current";
    } else {
      return "";
    }
  }

  showProgressAction(currentSlider, point) {
    if (currentSlider >= point) {
      return () => this.gotoSlide(point);
    } else {
      return null;
    }
  }

  showOptionNumber() {
    if (this.state.plan != null && ((this.isDayTimePlan() && this.isPerPersonPlan()) || this.isStayPlan())) {
      return "人数/オプション";
    } else {
      return "オプション";
    }
  }

  showOptionNumberClass(currentSlider) {
    if (this.state.plan != null && ((this.isDayTimePlan() && this.isPerPersonPlan()) || this.isStayPlan())) {
      return "sp-reserve-progressbar__step-option-number " + this.showProgressStatus(currentSlider, 3);
    } else {
      return this.showProgressStatus(currentSlider, 3);
    }
  }

  showHeaderStatement() {
    const slider = this.state.currentSlider;
    switch (slider) {
      case 0:
        return "プランを選択してください";
        break;
      case 1:
        return "プランを選択してください";
        break;
      case 2:
        return "利用期間を選択してください";
        break;
      case 3:
        if (this.state.plan != null && ((this.isDayTimePlan() && this.isPerPersonPlan()) || this.isStayPlan())) {
          return "必要な人数/オプションを選択してください";
        } else {
          return "必要なオプションを選択してください";
        }
        break;
      default:
        return "";
    }
  }

  cancelHourButton() {
    $(this.refs.hourlyTable).removeClass("md-show");
    this.requestParams.reserved_schedules = [];
    this.setState({
      isValid: false,
      rentType : this.state.plan.rent_type,
      priceText: "",
      priceExtraText: "",
      reservedDateText: I18n.t("service.label_000050"),
      validatedReservation: null,
    });
  }

  closeHourList() {
    $(this.refs.hourlyTable).removeClass("md-show");
    setTimeout(() => {
      this.setState({currentSlider: 3});
      this.nextSlide();
    }, 500);
  }

  hourDidSelect(selectedHour, e) {
    e.preventDefault();
    const plan = this.state.plan;
    const startedAt = new Date(Date.UTC(this.state.year, this.state.month - 1, this.state.day, selectedHour));
    let isSessionStart = false;
    let duration = 60;
    if (plan.has_session_price) {
      duration *= plan.min_required_session_hour;
      isSessionStart = true;
    }
    this.scheduleDidSelect(startedAt, duration, isSessionStart);
  }

  dayDidSelect(year, month, day, calendars) {
    super.dayDidSelect(year, month, day, calendars);

    setTimeout(() => {
      $(this.refs.hourlyTable).niftyModal();
    }, 100);
  }

  planDidSelect(index, e) {
    super.planDidSelect(index, e);

    setTimeout(() => {
      this.setState({currentSlider: 1});
      this.nextSlide();
    }, 100);
  }

  priceTypeDidSelect(e) {
    super.priceTypeDidSelect(e);

    setTimeout(() => {
      this.setState({currentSlider: 2});
      this.nextSlide();
    }, 100);
  }

  renderProgressBar() {
    const currentSlider = this.state.currentSlider;
    const planClassName = this.showProgressStatus(currentSlider, 0);
    const planAction = this.showProgressAction(currentSlider, 0);
    const periodClassName = this.showProgressStatus(currentSlider, 2);
    const periodAction = this.showProgressAction(currentSlider, 2);
    const optionAction = this.showProgressAction(currentSlider, 3);

    return (
      <div className="sp-reserve-progressbar" onClick={this.clearReloadSession.bind(this)}>
        <ul className="sp-reserve-progressbar__step">
          <li className={planClassName}>
            <div onClick={planAction}>
              <div className="sp-reserve-progressbar__step-button" />
              プラン
            </div>
          </li>
          <li className={periodClassName}>
            <div onClick={periodAction}>
              <div className="sp-reserve-progressbar__step-button" />
              期間
            </div>
          </li>
          <li className={this.showOptionNumberClass(currentSlider)}>
            <div onClick={optionAction}>
              <div className="sp-reserve-progressbar__step-button" />
              {this.showOptionNumber()}</div>
          </li>
        </ul>
        <p className="sp-reserve-progressbar__step-notes">{this.showHeaderStatement()}</p>
      </div>
    );
  }

  renderPlans(room) {
    let rows = [];
    let roomPlans = [this.state.room].concat(room.plans);

    roomPlans.forEach((plan, index)=>{
      const name = plan.plan_name || plan.name;
      const description = (index == 0) ? plan.plan_description : plan.description;
      const id = sprintf("plan-radio__%s", plan.id);

      let prices = [];
      if (plan.has_session_price) {
        prices.push(
          <div key="session_price" className="sp-reserve-plan__price-number">{plan.session_price_text}<span className="sp-reserve-plan__price-utility">/{plan.session_price_unit_text}〜</span></div>
        );
      }
      if (plan.has_hourly_price) {
        prices.push(
          <div key="hourly_price" className="sp-reserve-plan__price-number">{plan.hourly_price_text}<span className="sp-reserve-plan__price-utility">/{plan.hourly_price_unit_text}〜</span></div>
        );
      }
      if (plan.has_daily_price) {
        prices.push(
          <div key="daily_price" className="sp-reserve-plan__price-number">{plan.daily_price_text}<span className="sp-reserve-plan__price-utility">/{plan.daily_price_unit_text}〜</span></div>
        );
      }
      if (plan.has_stay_price) {
        prices.push(
          <div key="stay_price" className="sp-reserve-plan__price-number">{plan.stay_price_text}<span className="sp-reserve-plan__price-utility">/{plan.stay_price_unit_text}〜</span></div>
        );
      }

      const isChecked = this.state.plan && plan.id == this.state.plan.id;

      rows.push(
        <div key={plan.id} onClick={() => this.planDidSelect(index)}
             className="sp-reserve-card__inner sp-reserve-plan__content clearfix">
          <div className="sp-reserve-plan__price">
            {prices}
          </div>
          <div className="sp-reserve-plan__name">
            <input type="radio" defaultChecked={isChecked} value={plan.id} id={id} name="plan_id" />
            <label htmlFor={id} className="service-radio"><span className="sp-reserve-plan__title">{name}</span>
              {SMRenderHelper.renderDirectReservationIcon(plan)}
              {SMRenderHelper.renderLastMinuteDiscountIcon(plan)}
              {SMRenderHelper.renderMinRequiredDateOrTime(plan, "sp-reserve-plan__period")}
              {SMRenderHelper.renderHasRequiredFood(plan, "sp-reserve-plan__period")}
            </label>
          </div>
          <div className="sp-reserve-plan__notes">
            <p className="sp-reserve-plan__notes-text">{description}</p>
          </div>
        </div>
      );
    });
    return rows;
  }

  renderPriceType() {
    const plan = this.state.plan;
    const planId = SMPlanHelper.isRoom(plan) ? 0 : plan.id;
    let rows = [];
    if (plan.has_stay_price) {
      const id = sprintf("reserve-type__radio--stay-%s", planId);
      rows.push(
        <p key={id} className="sp-reserve-type__button">
          <input onChange={this.priceTypeDidSelect} checked={true} id={id} type="radio" name="is_hourly" value={0} className="sp-reserve-type__button-radio" />
          <label htmlFor={id} className="sp-reserve-type__button-label">{I18n.t("service.label_000400")}<span className="sp-reserve-type__price">{plan.stay_price_text}/{plan.stay_price_unit_text}〜</span></label>
        </p>
      );
    } else if (plan.has_session_price) {
      const id = sprintf("sp-reserve-type__radio--session-%s", planId);
      const isHourly = plan.min_required_session_hour_unit == SMConst.RequiredUnit.Hour ? 1 : 0;

      rows.push(
        <p key={id} className="sp-reserve-type__button">
          <input onChange={this.priceTypeDidSelect} checked={true} id={id} type="radio" name="is_hourly" value={isHourly} className="sp-reserve-type__button-radio" />
          <label htmlFor={id} className="sp-reserve-type__button-label">回ごと価格<span className="sp-reserve-type__price">{plan.session_price_text}/{plan.session_price_unit_text}〜</span></label>
        </p>
      );
    } else {
      if (plan.has_hourly_price) {
        const id = sprintf("reserve-type__radio--hourly-%s", planId);
        rows.push(
          <p key={id} className="sp-reserve-type__button">
            <input onChange={this.priceTypeDidSelect} checked={this.state.isHourly == true} id={id} type="radio" name="is_hourly" value={1} className="sp-reserve-type__button-radio" />
            <label htmlFor={id} className="sp-reserve-type__button-label">時間価格<span className="sp-reserve-type__price">{plan.hourly_price_text}/{plan.hourly_price_unit_text}〜</span></label>
          </p>
        );
      }
      if (plan.has_daily_price) {
        const id = sprintf("sp-reserve-type__radio--daily-%s", planId);
        rows.push(
          <p key={id} className="sp-reserve-type__button">
            <input onChange={this.priceTypeDidSelect} checked={this.state.isHourly == false} id={id} type="radio" name="is_hourly" value={0} className="sp-reserve-type__button-radio" />
            <label htmlFor={id} className="sp-reserve-type__button-label">1日価格<span className="sp-reserve-type__price">{plan.daily_price_text}/{plan.daily_price_unit_text}〜</span></label>
          </p>
        );
      }
    }
    return(
      <div ref="priceTypeContainer" key="price_type">
        <fieldset>
          <div className="sp-reserve-card">
              <div className="sp-reserve-card__inner sp-reserve-type clearfix">
                {rows}
              </div>
            <input type="hidden" name="rent_type" value={this.state.rentType} />
          </div>
        </fieldset>
      </div>
    );
  }

  renderCheckinAt() {
    let checkinAtDate = new Date(this.requestParams.reserved_schedules[0]["started_at"]);
    let checkinStartHour = this.state.checkinEnable;

    let checkinEndHour =  this.state.plan.has_extra_stay_checkinout_hour ?
      this.state.plan.extra_stay_checkin_end_hour : this.props.room.stay_checkin_end_hour;

    let checkinAtRows = [];
    let checkinDefault = checkinStartHour.toString() + ":00";
    if (this.state.validatedReservation && this.state.validatedReservation.checkin_time) {
      checkinDefault = this.state.validatedReservation.checkin_time;
    }
    for (let i = checkinStartHour; i <= checkinEndHour; i++) {
      let hour = i;
      let checkinTimeZero = i.toString() + ":00";
      let checkinTimeHalf = i.toString() + ":30";
      if (i == checkinStartHour) {
        checkinAtRows.push(<option key={checkinTimeZero} value={checkinTimeZero}>{checkinTimeZero}</option>);
        checkinAtRows.push(<option key={checkinTimeHalf} value={checkinTimeHalf}>{checkinTimeHalf}</option>);
      } else {
        checkinAtRows.push(<option key={checkinTimeZero} value={checkinTimeZero}>{checkinTimeZero}</option>);
        if (i == checkinEndHour) {
          break;
        } else {
          checkinAtRows.push(<option key={checkinTimeHalf} value={checkinTimeHalf}>{checkinTimeHalf}</option>);
        }
      }
    }

    return (
      <div className="sp-reserve-stay__line-innner">
        <label>
          <span className="sp-reserve-stay__line-innner-title">チェックイン時刻</span>
          <span className="sp-reserve-stay__line-innner-form">
            <span className="service-select">
              <select onChange={this.checkinAtDidSelect} name="checkin_at" id="checkin_at" className="service-select__purpose w110" defaultValue={checkinDefault}>
                {checkinAtRows}
              </select>
            </span>
         </span>
        </label>
        <span className="sp-reserve-stay__checkin-time">チェックイン可能時刻：{checkinStartHour.toString() + ":00～" + checkinEndHour.toString() + ":00"}</span>
      </div>
    );
  }

  renderCalendar(room) {
    if (this.props.isHourly === null) return null;

    return (
      <div ref="scheduleContainer" key="schedules">
        <fieldset>
          {(()=>{
            if (this.isStayPlan()) {
              return (
                <SMStayReservationCalendarMobileView
                  delegate={this}
                  room={room}
                  reservation={this.requestParams}
                  calendarState={this.state.calendarState}
                  plan={this.state.plan}
                />
              );
            } else {
              return (
                <SMReservationCalendarMobileView
                  delegate={this}
                  room={room}
                  reservation={this.requestParams}
                  calendarState={this.state.calendarState}
                  plan={this.state.plan}
                  isHourly={this.state.isHourly}
                />
              );
            }
          })()}
        </fieldset>
      </div>
    );
  }

  renderHoursCalendar(room) {
    let rows = [];
    const interval = 60;
    const reservedSchedules = this.requestParams.reserved_schedules;
    this.state.calendars.forEach((calendar, index) => {
      if (calendar.status == SMConst.RoomStatus.Available) {

        let className = "",
          targetHour = index >= 24 ? index - 24 : index;
        reservedSchedules.some((schedule) => {
          for (let i = 0; i < schedule.duration; i += interval) {
            let date = new Date(schedule.started_at);
            date.setUTCHours(date.getUTCHours() + i / interval);
            if (calendar.year == date.getUTCFullYear() && calendar.month == date.getUTCMonth() + 1 &&
              calendar.day == date.getUTCDate() && targetHour == date.getUTCHours()) {
              if (this.state.plan.has_session_price) {
                if (i == 0) {
                  className = "is-reserved is-checked";
                } else {
                  className = "is-reserved";
                }
              } else {
                className = "is-reserved is-checked";
              }
              return true;
            }
          }
        });

        const calendarPrice = calendar.is_last_minute_discount
            ? <span className="reserve-period__hourly-status is-discount"><i className="icon-spm-discount fa-lg"></i>{calendar.price_text}</span>
            : <span className="reserve-period__hourly-status">{calendar.price_text}</span>;

        rows.push(
          <li className={className} key={index}>
            <a onClick={(e) => this.hourDidSelect(index, e)} href="#">
              <div className="sp-reserve-period__hourly-content">
                <span className="sp-reserve-period__hourly-time">{calendar.hour}:00 - {calendar.hour + 1}:00</span>
                {calendarPrice}
              </div>
            </a>
          </li>
        );
      }
      else if (calendar.status == SMConst.RoomStatus.Full ||
        calendar.status == SMConst.RoomStatus.Disable ||
        calendar.status == SMConst.RoomStatus.Request) {
        rows.push(
          <li key={index} className="is-unavailable">
            <div className="sp-reserve-period__hourly-content">
              <span className="sp-reserve-period__hourly-time">{calendar.hour}:00 - {calendar.hour + 1}:00</span>
              <span className="sp-reserve-period__hourly-status">{calendar.status_text}</span>
            </div>
          </li>
        );
      }
      else {
        rows.push(
          <li key={index} className="is-closed">
            <div className="sp-reserve-period__hourly-content">
              <span className="sp-reserve-period__hourly-time">{calendar.hour}:00 - {calendar.hour + 1}:00</span>
              <span className="sp-reserve-period__hourly-status">{calendar.status_text}</span>
            </div>
          </li>
        );
      }
    });

    return (
      <div ref="hourlyTable" className="md-modal md-effect-3">
        <div className="md-content">
          <div>
            <div className="sp-reserve__header">
            <p ref="hourListHeader" className="sp-reserve-title__period">利用時間の選択
              <span onClick={() => this.cancelHourButton()} className="sp-reserve-title__close">キャンセル</span>
            </p>
           </div>
            <ul ref="hourList" style={{paddingTop: '39px', paddingBottom: this.calcFooterHeight() + "px"}} className="sp-reserve-period__hourly js-mobile-hourlist">
              {rows}
            </ul>
            {this.renderResult(room)}
          </div>
        </div>
      </div>
    );
  }

  renderNumberOfGuests() {
    const stayCapacity = this.isStayPlan() ? this.props.room.stay_capacity : this.props.room.capacity;
    let optionRows = [];
    let priceText = "";
    if (this.isStayPlan()) {
      priceText = this.state.plan.stay_price_text;
    } else if (this.state.plan.has_session_price) {
      priceText = this.state.plan.session_price_text;
    } else {
      if (this.state.isHourly == "1") {
        priceText = this.state.plan.hourly_price_text;
      } else {
        priceText = this.state.plan.daily_price_text;
      }
    }

    // オプション→期間→オプションの際に入力した値が消えないようrequestParamsから状態を復活する
    let numberOfGuest = 1;
    if (this.requestParams.number_of_guests) {
      numberOfGuest = this.requestParams.number_of_guests;
    }

    let perPersonLabel = this.isPerPersonPlan() ?
      <span className="sp-reserve-stay__checkin-time">利用人数ごとに料金が加算されます ({priceText}/人)</span> : "";

    return (
      <div className="sp-reserve-stay__line-innner sp-reserve-stay__line-innner-one">
        <span className="sp-reserve-stay__line-innner-title">利用人数</span>
        <div className="sp-reserve-option__number">
          <input className="js-reserve__spinner_guests" name="value" defaultValue={numberOfGuest} readOnly="readonly" />
        </div>
        {perPersonLabel}
      </div>
    );
  }

  renderStayGuestInfo() {
    return (
      <fieldset>
        <div className="sp-reserve-card">
          <div className="sp-reserve-card__inner">
            <div className="sp-reserve-stay__line">
              {this.renderNumberOfGuests()}
              {this.renderCheckinAt()}
            </div>
          </div>
        </div>
      </fieldset>
    );
  }

  renderGuestInfo() {
    return (
      <fieldset>
        <div className="sp-reserve-card">
          <div className="sp-reserve-card__inner clearfix">
            <div className="sp-reserve-stay__line">
              {this.renderNumberOfGuests()}
            </div>
          </div>
        </div>
      </fieldset>
    );
  }

  renderSelectOptions(room) {
    return(
      <fieldset>
        <div className="sp-reserve-card">
          <h2 style={SMRenderHelper.hideIfEmpty(room.option_items)} className="sp-reserve-option__headline">設備・サービス</h2>
          {this.renderOptionItems(room)}
          <h2 style={SMRenderHelper.hideIfEmpty(room.option_foods)} className="sp-reserve-option__headline">飲食</h2>
          {this.renderOptionFoods(room)}
        </div>
      </fieldset>
    );
  }

  renderOptions(room) {
    const isHourly = this.state.isHourly;

    if (isHourly === null) return null;
    if (room.option_items.length == 0 && room.option_foods.length == 0) return null;

    return (
      <div style={{paddingBottom: this.calcFooterHeight() + "px"}}>
        {this.isStayPlan() && this.requestParams.stay_checkin_at && this.requestParams.stay_checkout_at ? this.renderStayGuestInfo(room) : null}
        {this.isDayTimePlan() && this.isPerPersonPlan() ? this.renderGuestInfo(room) : null}
        {this.renderSelectOptions(room)}
      </div>
    );
  }

  renderOptionFoods(room) {
    let rows = [];
    room.option_foods.forEach((item, index)=>{
      const id = sprintf("reserve-option-food__checkbox%s", item.id);
      const style = !item.countable || item.max_count < 2 ? {display: "none"} : {};

      // オプション→期間→オプションの際にチェックした値が消えないようにrequestParamsから状態を復活する
      let defaultChecked = false;
      let defaultNumber = 1;
      if (this.requestParams.reserved_option_foods) {
        const selectedOptionFood = this.requestParams.reserved_option_foods.find(target => target.option_food_id == item.id);
        if (selectedOptionFood) {
          defaultChecked = true;
          defaultNumber = selectedOptionFood.number;
        }
      }

      rows.push(
        <div key={item.id} className="sp-reserve-card__inner clearfix">
          <div className="sp-reserve-option__content">
            <div style={style} className="sp-reserve-option__number">
              <input data-option-type="food" data-index={index} className="js-reserve__spinner" id={id + "__number"} name="value" defaultValue={defaultNumber} readOnly="readonly" />
            </div>
            <div className="sp-reserve-option__content-headline">
              <input onChange={(e) => this.optionFoodDidSelect(index, e)} type="checkbox" id={id} name="sp-reserve-option__service" defaultChecked={defaultChecked} />
              <label htmlFor={id} className="service-checkbox">
                <span className="sp-reserve-option__name">{item.name}</span><span className="sp-reserve-option__price">{item.price_text}<span className="sp-reserve-option__price-number">/{item.price_unit_text}</span></span>
              </label>
            </div>
            <div className="sp-reserve-option__content-notes">
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      );
    });
    return rows;
  }

  renderOptionItems(room) {
    let rows = [];
    room.option_items.forEach((item, index)=>{
      const id = sprintf("reserve-option-item__checkbox-%s", item.id);
      const style = !item.countable || item.max_count < 2 ? {display: "none"} : {};

      // オプション→期間→オプションの際にチェックした値が消えないようにrequestParamsから状態を復活する
      let defaultChecked = false;
      let defaultNumber = 1;
      if (this.requestParams.reserved_option_items) {
        const selectedOptionItem = this.requestParams.reserved_option_items.find(target => target.option_item_id == item.id);
        if (selectedOptionItem) {
          defaultChecked = true;
          defaultNumber = selectedOptionItem.number;
        }
      }

      rows.push(
        <div key={item.id} className="sp-reserve-card__inner clearfix">
          <div className="sp-reserve-option__content">
            <div style={style} className="sp-reserve-option__number">
              <input data-option-type="item" data-index={index} className="js-reserve__spinner" id={id + "__number"} name="number" defaultValue={defaultNumber} readOnly="readonly" />
            </div>
            <div className="sp-reserve-option__content-headline">
              <input onChange={(e) => this.optionItemDidSelect(index, e)} type="checkbox" id={id} defaultChecked={defaultChecked} />
              <label htmlFor={id} className="service-checkbox">
                <span className="sp-reserve-option__name">{item.name}</span><span className="sp-reserve-option__price">{item.price_text}<span className="sp-reserve-option__price-number">/{item.price_unit_text}</span></span>
              </label>
            </div>
            <div className="sp-reserve-option__content-notes">
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      );
    });
    return rows;
  }

  renderResult(room) {
    let mobileRows = [];
    const isValid = this.state.isValid;
    const errors = this.state.errors;
    const plan = this.state.plan;
    const validatedReservation = this.state.validatedReservation;
    const priceText = this.state.priceText;
    const priceExtraText = this.state.priceExtraText;
    const currentUser = this.props.currentUser;

    if (!isValid) {
      if (errors && errors.length > 0) {
        errors.forEach((error, index) => {
          mobileRows.push(
            <p key={index} className="sp-reserve-payment__notify-info-time"><i className="fa fa-exclamation-circle"></i>{error.message}</p>
          );
        });
      } else {
        if (plan && validatedReservation) {
          if (SMPlanHelper.shoudRenderMinRequiredDate(plan)) {
            mobileRows.push(
              <p key="min_hour" className="sp-reserve-payment__notify-info-time">
                最低利用日数は<strong>{plan.min_required_hour}日間</strong>です。</p>
            );
          } else if (SMPlanHelper.shouldRenderMinRequiredTime(plan)) {
            mobileRows.push(
              <p key="min_hour" className="sp-reserve-payment__notify-info-time">
                最低利用時間は<strong>{plan.min_required_hour}時間</strong>です。</p>
            );
          }
          if (SMPlanHelper.shouldRenderRequiredFood(plan)) {
            mobileRows.push(
              <p key="food" className="sp-reserve-payment__notify-info-time">このプランは飲食が<strong>必須</strong>です。</p>
            );
          }
        }
      }
    }
    if (priceText) {
      mobileRows.push(
        <p key="price" className="sp-reserve-payment__notify-info-payment">{priceText} {priceExtraText}</p>
      );
    }

    if (!currentUser) {
      mobileRows.push(
        <p className="sp-reserve-payment__notify-info-login">予約するにはログインが必要です。</p>
      );
    }
    let buttonLabel = "予約リクエストへ進む";

    if (validatedReservation && validatedReservation.is_last_minute_discount_warning) {
      mobileRows.push(
        <p key="last_minute_discount" className="reserve-situation__required">
          <i className="fa fa-exclamation-circle"></i>直前割期間対象外の利用期間が存在するため、<br />直前割は適用されません。</p>
      );
    }

    let inner = null;
    if (validatedReservation) {
      let buttonClassName = "button-blue sp-reserve-payment__notify-button";
      if (!isValid) {
        buttonClassName += " button-disabled";
      }

      let buttonAction = (e) => this.showRequestView(e);
      if (this.state.currentSlider === 2) {
        buttonAction = (() => this.closeHourList());
        buttonLabel = "利用時間を決定する";
      }

      if (this.isStayPlan()) {
        inner = (
          <div ref="footer" className="sp-reserve__footer">
            <div className="sp-reserve-payment__notify-info">
              {mobileRows}
            </div>
            <a onClick={buttonAction} className={buttonClassName}>{buttonLabel}</a>
          </div>
        );
      } else {
        inner = (
          <div ref="footer" className="sp-reserve__footer">
            <div className="sp-reserve-payment__notify-info">
              {mobileRows}
            </div>
            <a onClick={buttonAction} className={buttonClassName}>{buttonLabel}</a>
          </div>
        );
      }
    } else if (mobileRows && mobileRows.length > 0) {
      inner = (
        <div ref="footer" className="sp-reserve__footer">
          <div className="sp-reserve-payment__notify-info">
            {mobileRows}
          </div>
        </div>
      );
    }

    return (
      <div>
        {inner}
      </div>
    );
  }

  render() {
    const room = this.state.room;

    const slickOptions = {
      dots: false,
      infinite: false,
      arrows: false,
      accessibility: false,
      draggable: false,
      speed: 300,
      touchMove: false,
      swipeToSlide: false,
      autoplay: false,
    };

    return (
      <div className="site-main">
        <div className="page__even">
          <form ref="form">
            <input type="hidden" name="reserved_schedules[][is_session_start]" value={room.space.id} />
            <div className="sp-reserve__header">
              <h1 className="sp-reserve-title">空き状況の確認／予約リクエスト<a href={this.props.roomPath}><span className="sp-reserve-title__close">閉じる</span></a></h1>
              {this.renderProgressBar()}
            </div>
            <div className="sp-reserve__main" ref="mobileMain">
              <ReactSlick ref={c => this.slider = c} {...slickOptions}>
                <div key="plan_slide">
                  <fieldset>
                    <div className="sp-reserve-card">
                      {!this.state.reloadSession ? this.renderPlans(room) : null}
                    </div>
                  </fieldset>
                </div>
                <div key="price_slide" className="sp-reserve-next">
                  {this.state.plan && !this.state.reloadSession ? this.renderPriceType() : null}
                </div>
                <div key="calendar_slide" className="sp-reserve-next">
                  {this.state.plan && !this.state.reloadSession ? this.renderCalendar(room) : null}
                </div>
                <div key="option_slide" className="sp-reserve-next">
                  {this.state.plan && this.state.isValid ? this.renderOptions(room) : null}
                </div>
              </ReactSlick>
            </div>
            {this.renderResult(room)}
            {this.state.calendars ? this.renderHoursCalendar(room) : null}
            <div className="md-overlay" />
          </form>
        </div>
        {this.renderReservationRequest()}
        <SMUserContactView
          delegate={this}
          currentUser={this.props.currentUser}
          isOpen={this.state.isContactViewOpen} />
       </div>
    );
  }
}
export default SMReservationMobileView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationMobileView.jsx